import React from "react";
import { observer } from "mobx-react";
import { Avatar } from "@mui/material";
import { PersonIcon } from "../../icons";
import { useAuthenticatedImage } from "../hooks/useAuthenticatedImage";
import type { FileData } from "../../api/graphql";

export interface AuthAvatarProps {
  avatarData?: FileData | null;
  name: string;
  userId: string;
  size?: number;
  cacheVersion?: number;
}

/**
 * Componente Avatar que carga imágenes con autenticación
 * Muestra iniciales del nombre como fallback durante carga o error
 */
export const AuthAvatar: React.FC<AuthAvatarProps> = observer(
  ({ avatarData, name, userId, size = 40, cacheVersion }) => {
    const { imageUrl, loading } = useAuthenticatedImage(
      avatarData,
      "User",
      "avatar",
      userId,
      cacheVersion
    );

    // Calcular iniciales del nombre (primeras 2 letras) o ícono genérico
    const initials = name ? name.slice(0, 2).toUpperCase() : null;

    // Si tenemos URL de imagen y no está cargando, usarla
    if (imageUrl && !loading) {
      return (
        <Avatar src={imageUrl} alt={name} sx={{ width: size, height: size }}>
          {initials}
        </Avatar>
      );
    }

    // Fallback: mostrar iniciales o ícono genérico
    return (
      <Avatar sx={{ width: size, height: size }}>
        {initials || <PersonIcon />}
      </Avatar>
    );
  }
);
